/* global UDS_API_URL, UDS_AUTHORIZATION_KEY */

import axios from 'axios';

const config = () => ({
  baseURL: UDS_API_URL,
  timeout: 3000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: UDS_AUTHORIZATION_KEY,
  },
});

const saveId = (id) => {
  const data = { anonymous_user: { id } };
  return axios.post('/anonymous_users', data, config());
};

export default { saveId };
